/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
import React, { useRef } from 'react';
import ReactModal from 'react-modal';
import { registerAnalyticsEvent } from '../Utilities/Analytics';

interface ModalOwnProps {
    children: JSX.Element;
    onRequestClose: () => void;
    isOpen: boolean;
    ariaCloseText: string;
    eventId?: string | null;
}

type ModalProps = ModalOwnProps;

export const ModalCompontent = (props: ModalProps): JSX.Element => {
    if (props.isOpen) {
        const yPos = window.pageYOffset;
        document.body.style.top = `-${yPos}px`;
        document.body.style.overflowY = 'hidden';
    }

    const onClose = (): void => {
        const scrollY = document.body.style.top;
        document.body.style.top = '';
        document.body.style.removeProperty('overflow-y');
        window.scrollTo(0, parseInt(scrollY || '0', 10) * -1);
        props.onRequestClose();
    };

    const scrollableDiv = useRef<HTMLDivElement>(null);

    const onOpen = (): void => {
        if (props.eventId !== undefined) {
            registerAnalyticsEvent({
                action: 'VeilederModalApnet',
                eventId: props.eventId,
            });
        }
        scrollableDiv.current?.focus();
    };

    return (
        <ReactModal
            portalClassName="c-modal"
            overlayClassName="c-modal__overlay"
            className="c-modal__content"
            isOpen={props.isOpen}
            onRequestClose={onClose}
            onAfterOpen={onOpen}
        >
            <div className="l-flow l-flow--col l-flow--full-width">
                <div className="c-modal__content-header">
                    <button
                        aria-label={props.ariaCloseText}
                        className="c-knapp c-knapp--icon c-knapp--icon-n c-knapp--icon-cross"
                        onClick={onClose}
                    />
                </div>
                <div ref={scrollableDiv} tabIndex={0} className="c-modal__content-body">
                    {props.children}
                </div>
            </div>
        </ReactModal>
    );
};
